import * as CardActionTypes from 'actiontypes/cards';
import {
  CHOOSE_STORYLET_REQUESTED,
  CHOOSE_STORYLET_SUCCESS,
  CHOOSE_STORYLET_FAILURE,
} from 'actiontypes/storylet';


import formatPayload from './formatPayload';
import reverseCards from './reverseCards';
import { ICardsState } from 'types/cards';

/**
 * Initial state
 * @type {Object}
 */
const INITIAL_STATE: ICardsState = {
  cardsCount: 0,
  deckSize: 0,
  displayCards: [],
  handSize: 0,
  isDrawing: false,
  isFetchingInBackground: false,
  isFetching: false,
  isPlaying: false,
  shouldFetch: false,
};

/**
 * Cards Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
export default function Cards(state = INITIAL_STATE, action: { type: string, payload: any, error?: any, status?: number }) {
  const { error, status } = action;
  const payload = formatPayload(action.payload || {});

  switch (action.type) {

    case CardActionTypes.CARDS_SHOULD_FETCH:
      return {
        ...state,
        shouldFetch: true,
      };

    case CardActionTypes.CLEAR_CACHE:
      return INITIAL_STATE;

    case CardActionTypes.BACKGROUND_FETCH_CARDS_REQUESTED:
      return {
        ...state,
        isFetchingInBackground: true,
      };

    case CardActionTypes.FETCH_CARDS_REQUESTED:
      return {
        ...state,
        isFetching: true,
      };

    case CardActionTypes.FETCH_CARDS_FAILURE:
      return {
        ...state,
        error,
        status,
        isFetching: false,
        isFetchingInBackground: false,
      };

    case CardActionTypes.FETCH_CARDS_SUCCESS:
      return {
        ...state,
        ...payload,
        // cardsCount: payload.eligibleForCardsCount,
        // deckSize: payload.maxDeckSize,
        // handSize: payload.maxHandSize,
        displayCards: reverseCards(payload),
        isFetching: false,
        isFetchingInBackground: false,
        shouldFetch: false,
      };

    case CardActionTypes.DISCARD_CARDS_FAILURE:
      return {
        ...state,
        error,
        status,
        isFetching: false,
      };

    case CardActionTypes.DISCARD_CARDS_REQUESTED:
      return {
        ...state,
        isFetching: true,
      };

    case CardActionTypes.DISCARD_CARDS_SUCCESS:
      return {
        ...state,
        ...payload,
        isFetching: false,
        displayCards: reverseCards(payload),
      };

    case CardActionTypes.DRAW_CARDS_REQUESTED:
      return {
        ...state,
        isDrawing: true,
        isFetching: true,
      };

    case CardActionTypes.DRAW_CARDS_FAILURE:
      return {
        ...state,
        isDrawing: false,
        isFetching: false,
        error,
        status,
      };

    case CardActionTypes.DRAW_CARDS_SUCCESS:
      return {
        ...state,
        ...payload,
        isDrawing: false,
        isFetching: false,
        displayCards: reverseCards(payload),
      };

    case CHOOSE_STORYLET_REQUESTED:
      return { ...state, isPlaying: true };

    case CHOOSE_STORYLET_SUCCESS:
    case CHOOSE_STORYLET_FAILURE:
      return { ...state, isPlaying: false };

    default:
      return state;
  }
}